/* eslint-disable block-scoped-var,eqeqeq,@typescript-eslint/no-redeclare,@typescript-eslint/no-shadow,no-underscore-dangle,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,no-var,vars-on-top */

import { DESIGNER_EVENTS } from '../../../app/constants/designer_events';

xplenty.service('errorsViewerService', [
  '$rootScope',
  '$compile',
  '$window',

  function ($rootScope, $compile, $window) {
    let _this;

    const $win = angular.element($window);
    const errorsViewerService = {};

    errorsViewerService.errorsViewers = [];

    const ErrorsViewer = function (title, designer) {
      _this = this;

      this.designer = designer;
      this.$scope = $rootScope.$new();
      this.$scope.errors = [];
      this.$scope.title = title || 'Errors Viewer';
      this.hidden = true;
      this.$scope.hide = function () {
        _this.hide();
      };
      this.$scope.revalidate = () => {
        $rootScope.$broadcast(DESIGNER_EVENTS.REVALIDATE);
      };
      // eslint-disable-next-line global-require
      this.$scope.element = $compile(require('../../../views/error-viewer.html'))(this.$scope);
      this.$scope.element.draggable({
        handle: '.errors-viewer-header',
        containment: 'parent',
        scroll: false,
        stop() {
          _this.$scope.element.css('height', 'auto');
        },
      });

      this.$scope.openComponent = function (component) {
        angular.isFunction(component.setSelection) && $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_EDIT, component);
      };

      this.$scope.selectComponent = function (component) {
        angular.isFunction(component.setSelection) && component.setSelection(true);
      };

      this.$scope.unselectComponent = function (component) {
        angular.isFunction(component.setSelection) && component.setSelection(false);
      };

      angular.element($window.document).on('keyup', function (e) {
        if (e.keyCode == 27 && _this.hidden) {
          _this.hide();
        }
      });

      angular.element('body').append(this.$scope.element);

      this.show();
    };

    ErrorsViewer.prototype.setErrors = function (errors) {
      const components = [];

      _.each(errors, function (error) {
        if (error.component_id) {
          var component = _.find(components, function (component) {
            return component.id === error.component_id;
          });
          if (!component) {
            var component = _this.designer.package.getComponentById(error.component_id);
            if (component) {
              component.errors = [];
              component.errors.push(error.message);
              components.push(component);
            }
          }
        } else {
          var component = _.find(components, { id: 'general' });
          if (!component) {
            var component = {
              id: 'general',
              name: 'General errors',
              errors: [],
            };
            component.errors.push(error.message);
            components.push(component);
          } else {
            component.errors.push(error.message);
          }
        }
      });

      this.$scope.components = components;
    };

    ErrorsViewer.prototype.resize = function () {
      const windowHeight = $window.innerHeight;
      const $errorsBody = _this.$scope.element.find('.errors-viewer-body');
      const topPosition = _this.$scope.element.position().top;
      $errorsBody.css('max-height', windowHeight - topPosition - 140);
    };

    let redirectEvent;

    ErrorsViewer.prototype.show = function () {
      this.resize();
      this.$scope.element.show();
      this.hidden = true;
      $win.on('resize', this.resize);
      redirectEvent = $rootScope.$on('$stateChangeSuccess', function () {
        _this.hide();
      });
    };

    ErrorsViewer.prototype.hide = function () {
      this.$scope.element.hide();
      this.hidden = false;
      $win.off('resize', this.resize);
      if (redirectEvent) redirectEvent();
    };

    errorsViewerService.createView = function (title, designer) {
      const errorsViewer = new ErrorsViewer(title, designer);

      errorsViewerService.errorsViewers.push(errorsViewer);

      return errorsViewer;
    };

    ErrorsViewer.prototype.destroy = function () {
      this.$scope.element.remove();
      this.$scope.$destroy();
    };

    return errorsViewerService;
  },
]);
